import axios from "@/services/interceptors";

const state = {
  sensors: undefined,
  sensorsLoading: false,
};

const getters = {
  meetnetConfig(state, getters, rootState) {
    return rootState.config?.meetnet;
  },
  sensors(state) {
    if (state.sensors) {
      state.sensors.sort(function(a, b) {
        var dateB = new Date(b.last_update);
        var dateA = new Date(a.last_update);
        if (dateB < dateA) {
          return -1;
        }
        if (dateB > dateA) {
          return 1;
        }
        return 0;
      });
      return state.sensors;
    } else {
      return [];
    }
  },
  sensorsLoading(state) {
    return state.sensorsLoading;
  },
};

const mutations = {
  setSensors(state, payload) {
    state.sensors = payload;
  },
  setSensorsLoading(state, value) {
    state.sensorsLoading = value;
  },
};

const actions = {
  setSensor(context, payload) {
    context.commit("setSensors", payload);
  },

  setSensorsLoading(context, value) {
    context.commit("setSensorsLoading", value);
  },

  getSensor(context, pk) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/sensor/${pk}/`,
    });
  },

  getSensorInstallations(context, pk) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/sensor/${pk}/get_sensor_locations/`,
    });
  },

  getSensors({ getters }) {
    /*
    In the backend, Sensors are linked to Organisations, not Newtworks
    So it is sufficient to get the sensors for one Network
    It will always return the complete list of sensors for the Organisation the user belongs to and is allowed to access
    */
    return axios.get(
      `${getters.meetnetAPIURL}/sensoren/measurementnetwork/${getters.measurementNetworkIDs[0]}/get_sensors/`
    );
  },

  searchSensors(context, query) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/sensor/?search=${query}`,
    });
  },

  getUnlinkedSensors(context) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/sensor/get_unlinked_sensors/`,
    });
  },

  createMeasurementSensor(context, payload) {
    return axios({
      method: "POST",
      data: payload,
      url: `${context.getters.meetnetAPIURL}/sensoren/sensor/`,
    });
  },

  updateMeasurementSensor(context, payload) {
    return axios({
      method: "PATCH",
      data: payload,
      url: `${context.getters.meetnetAPIURL}/sensoren/sensor/${payload.serial_number}/`,
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
